export function syncAngledBanner(conf, form) {
  const banner = conf.angledBanner;
  const errors = {};

  if (!banner) {
    return errors;
  }

  const svg = document.querySelector('div.template svg');
  const group = svg?.querySelector(`#${banner.elementId}`);
  const background = svg?.querySelector(`#${banner.backgroundId}`);

  if (!group || !background) {
    return errors;
  }

  const variants = conf.productVariants;
  const product = variants && form.layerStatus?.[variants.sourceLayer]
    && variants.texts[form.layerItems?.[variants.sourceLayer]];
  const top = product ? banner.productY : banner.defaultY;
  group.setAttribute('transform', `translate(0, ${top}) skewY(${banner.angle})`);

  [banner.textId, banner.aboveTextId].forEach(id => {
    const field = conf.texts.find(text => text.id === id);
    const target = svg.querySelector(`#${id}`);

    if (!field || !target) {
      return;
    }

    const enabled = form.textsStatus?.[id] ?? Boolean(field.enabled);
    const color = field.colors.includes(form.textsColors?.[id])
      ? form.textsColors[id]
      : field.defaultColor;

    // Use the same HTML wrapping as other templates, preserving manual breaks.
    target.textContent = form.texts?.[id] ?? field.placeholder ?? '';
    target.style.color = `rgb(${color})`;
    target.style.visibility = enabled ? 'visible' : 'hidden';

    const lineHeight = Number.parseFloat(window.getComputedStyle(target).lineHeight);
    const maxHeight = field.maxLines * lineHeight;
    target.style.maxHeight = `${maxHeight}px`;

    if (enabled && target.scrollHeight > maxHeight + 1) {
      errors[id] = `Bitte kürzen Sie den Text auf maximal ${field.maxLines} Zeilen.`;
    }

    const box = target.closest('foreignObject');
    const height = target.offsetHeight;
    box.setAttribute('height', Math.max(height, 1));

    if (id === banner.textId) {
      background.setAttribute('width', Number(box.getAttribute('x')) + target.offsetWidth + banner.padding);
      background.setAttribute('height', Number(box.getAttribute('y')) + height + banner.padding);
      background.style.visibility = enabled && target.textContent.trim() ? 'visible' : 'hidden';
    } else {
      box.setAttribute('y', -banner.aboveGap - height);
    }
  });

  return errors;
}
